import {EquipmentPlain} from '@hconnect/common/types'
import moment from 'moment-timezone'

import {
  DalogActionDto,
  TaskSource,
  DalogActionFormValues,
  EditDalogAction,
  EditDalogActionDto
} from '../types'

export const mapToDalogActionFormValues = (
  data: DalogActionDto,
  timezone: string
): DalogActionFormValues => {
  return {
    ...data,
    dueDate: data.dueDate ? moment.tz(data.dueDate, timezone).toISOString() : null,
    ...(data.assignees && {
      assignees: data.assignees
    }),
    source: TaskSource.DALOG_ACTIONS,
    functionalLocation: data.dalogProperties?.functionalLocation ?? null,
    processStage: data.processStage,
    ...(data.equipment && {
      equipment: {
        equipment: data.equipment,
        ...(data.processStage && {processStage: {processStep: data.processStage}}),
        ...(data.mainEquipment && {mainEquipment: data.mainEquipment})
      } as EquipmentPlain
    })
  }
}

const mapToEditDalogActionDto = (formValues: DalogActionFormValues): EditDalogActionDto => {
  const {assignees, mainEquipment, equipment, dueDate, ...rest} = formValues

  return {
    ...rest,
    equipmentId: equipment?.equipment.id,
    equipmentIdType: equipment?.equipment.idType,
    equipmentText: equipment?.equipment.text,
    mainEquipmentId: mainEquipment?.id,
    mainEquipmentIdType: mainEquipment?.idType,
    mainEquipmentText: mainEquipment?.text,
    dueDate: dueDate ?? '',
    assignees: assignees.map((assignee) => assignee.id)
  }
}

export const mapToDalogAction = (
  formValues: DalogActionFormValues,
  id: string,
  plantUpmId: string
): EditDalogAction => {
  return {
    ...mapToEditDalogActionDto(formValues),
    id,
    plantUpmId
  }
}
